module.exports = true;



//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/_library.js
// module id = O4g8
// module chunks = 0